import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9z8pu8jvce: FaireBrandEntity = {
  token: "b_9z8pu8jvce",
  type: "brand",
  name: "Rising Sun Distributors",
  avatarUrl:
    "https://cdn.faire.com/fastly/558e28c845a19885914fe7274c79670d167027e3ef44e8eb8f043f3ffd06e7b7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dd3189279f8400b4e3ba489f5b61284a4cdef605271f4fc428bd37bd73eb0bd7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/558e28c845a19885914fe7274c79670d167027e3ef44e8eb8f043f3ffd06e7b7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dd3189279f8400b4e3ba489f5b61284a4cdef605271f4fc428bd37bd73eb0bd7.png",
  location: "SADDLE BROOK, NJ, USA",
  minimumOrderDollars: 208,
  rating: 4.1,
  reviewCount: 9,
  isInsider: true,
  description:
    "Welcome to Rising Sun Distributors, your premier destination for authentic health products, Caribbean flavors and culinary delights. At Rising Sun, we are passionate about bringing the vibrant taste of the islands to kitchens around the world. Our journey began with a vision to share the rich heritage and bold flavors of Caribbean cuisine with discerning palates everywhere.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.865Z",
    importedBy: "entity-db-cli",
  },
};
